import { buildSectionSelector, normalizeSectionId, sectionRenderer } from '@theme/section-renderer';
import { requestIdleCallback, onDocumentReady } from '@theme/utilities';

/**
 * Hydrates a section using the Section Rendering API preserving states.
 *
 * @param {string} sectionId - The section ID to hydrate
 */
async function hydrateSection(sectionId) {
  const normalizedId = normalizeSectionId(sectionId);
  const section = document.getElementById(buildSectionSelector(normalizedId));

  if (!section || section.dataset.hydrated === 'true') {
    return;
  }

  await sectionRenderer.renderSection(normalizedId, { cache: false });

  section.dataset.hydrated = 'true';
}

/**
 * Hydrates a section when the DOM is ready, if the cart no longer matches what the page was
 * rendered with. A cached page can show a stale cart, but asking the cart is far cheaper than
 * refetching and morphing the whole section on every page view.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {number} renderedItemCount - The cart item count the page was rendered with
 */
export async function hydrateIfCartChanged(sectionId, renderedItemCount) {
  onDocumentReady(() => {
    requestIdleCallback(async () => {
      const cart = await fetch(`${Theme.routes.cart_url}.js`)
        .then((response) => response.json())
        .catch(() => null);

      if (cart?.item_count !== renderedItemCount) hydrateSection(sectionId);
    });
  });
}
